var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { get, isString } from "lodash";
import isContentKey from "./helpers/isContentKey";
export var PBERRUnknownError = "PBERRUnknownError";
export var PBERRInternalServerError = "PBERRInternalServerError";
export var PBERRTokenMissing = "PBERRTokenMissing";
export var PBERRTokenBuilderError = "PBERRTokenBuilderError";
export var PBERRForbiddenNoPermission = "PBERRForbiddenNoPermission";
export var PBERRForbiddenRestrictionCheckFailed = "PBERRForbiddenRestrictionCheckFailed";
export var PBERRForbiddenInvalidToken = "PBERRForbiddenInvalidToken";
export var PBERRForbiddenTokenExpired = "PBERRForbiddenTokenExpired";
export var PBERRForbiddenUnexpectedRestriction = "PBERRForbiddenUnexpectedRestriction";
export default function errorParser(err, func) {
    var errCode = getCode(err);
    switch (errCode) {
        case PBERRForbiddenNoPermission:
        case PBERRForbiddenRestrictionCheckFailed:
            return formatError(err, "errors.PBERRForbiddenNoPermission", errCode);
        case PBERRForbiddenInvalidToken:
        case PBERRTokenMissing:
            return formatError(err, "errors.PBERRForbiddenInvalidToken", errCode);
        default:
            return getDefaultMessage(err, errCode, func);
    }
}
function getDefaultMessage(err, code, func) {
    var output = "errors.unknownError";
    if (func) {
        output = func(code) || output;
    }
    return formatError(err, output, code);
}
function formatError(err, msg, code) {
    if (code === void 0) { code = ""; }
    err.message = msg;
    err.code = code;
    return err;
}
function getCode(err) {
    return (err.code || // simple assign
        err.errorCode || // graph response
        get(err, "response.data.code") || // REST API response
        get(err, "networkError.errorCode")); // other graph response
}
export var getMessage = function (err) {
    var msg = "There was some sort of error";
    var dataMsg = get(err, "response.data.message", null);
    var data = get(err, "response.data", null);
    var graphErrorCode = get(err, "networkError.data.errors[0].errorCode");
    if (isContentKey(err.message)) {
        msg = err.message;
    }
    else if (dataMsg) {
        msg = dataMsg;
    }
    else if (data) {
        msg = isString(data) ? data : JSON.stringify(data);
    }
    else if (err && err.msg) {
        msg = err.msg;
    }
    else if (graphErrorCode) {
        msg = "errors." + graphErrorCode;
    }
    else if (err && err.message) {
        msg = err.message;
    }
    return msg;
};
export var getValues = function (err) {
    var clone = __assign({}, err);
    var values = get(clone, "data") || get(clone, "errorData", {});
    var errorCode = getCode(err);
    values.errorCode = errorCode ? "(Code: " + errorCode + ")" : "";
    return values;
};
